/* eslint-disable react-hooks/exhaustive-deps */
import { Fragment, useContext, useEffect, useState } from 'react';
import { toast } from 'react-hot-toast';
import axios from 'axios';

import Header from '../../Components/Header/Header';
import Navbar from '../../Components/Navbar/Navbar';
import FormInput from '../../Components/FormInput/FormInput';
import PrimaryButton from '../../Components/Buttons/PrimaryButton';
import { useHistory } from 'react-router-dom';
import { authContext } from '../../store/AuthContext';



const Units = () => {

    const serverURL = process.env.REACT_APP_SERVER_URL;
    const token = JSON.parse(localStorage.getItem('token'));

    const history = useHistory();

    const authCtx = useContext(authContext);

    if (authCtx.adminType !== 'super' && authCtx.adminType !== 'data') {
        history.push('/form');
    }

    const defaaultUnitState = {
        name: '',
        property: ''
    }

    const [properties, setProperties] = useState([]);
    const [units, setUnits] = useState([]);
    const [currItem, setCurrItem] = useState(defaaultUnitState)

    const getSites = async () => {

        const res = await toast.promise(
            axios({
                method: 'GET',
                url: `${serverURL}/api/sites`,
                headers: {
                    'Authorization': `Bearer ${token}`
                }
            }),
            {
                loading: 'Fetching...',
                success: 'Data fetched successfully!',
                error: 'Could not get the data.',
            }
        )

        const { data } = res.data;
        setProperties(data);
    }

    const getUnits = async () => {
        const res = await toast.promise(
            axios({
                method: 'GET',
                url: `${serverURL}/api/units`,
                headers: {
                    'Authorization': `Bearer ${token}`
                }
            }),
            {
                loading: 'Fetching...',
                success: 'Data fetched successfully!',
                error: 'Could not get the data.',
            }
        )

        const { data } = res.data;
        setUnits(data);
    }

    const postData = async (event) => {
        event.preventDefault();

        const res = await toast.promise(
            axios({
                method: 'POST',
                url: `${serverURL}/api/units`,
                headers: {
                    "Authorization": `Bearer ${token}`,
                    "Content-Type": 'application/json'
                },
                data: {
                    ...currItem,
                    property: currItem.property.split('-')[0]
                }
            }), {
            loading: 'Creating...',
            success: 'Data created successfully!',
            error: 'Could not create the data.',
        }
        )
        if (res && res.status === 200) {
            const newUnits = [...units];
            newUnits.push({
                ...currItem,
                _id: res.data.data._id,
                property: {
                    name: currItem.property.split('-')[1],
                }
            });
            setUnits(newUnits);
        }

        setCurrItem(defaaultUnitState)
    }

    const deleteData = async (id) => {
        if (!id) {
            return toast.error('Please provide and ID')
        }

        const resFloorPlans = await toast.promise(
            axios({
                method: "DELETE",
                url: `${serverURL}/api/floor-plan/unit/${id}`,
                headers: {
                    "Authorization": `Bearer ${token}`
                }
            }), {
            loading: 'Deleting...',
            success: "Data deleted successfully",
            error: "Couldn't delete the data"
        }
        )

        if (!resFloorPlans || resFloorPlans.status !== 200) {
            toast.error("Couldn't delete the data");
        }

        const res = await toast.promise(
            axios({
                method: 'DELETE',
                url: `${serverURL}/api/units/${id}`,
                headers: {
                    "Authorization": `Bearer ${token}`
                }
            }),
            {
                loading: 'Deleting...',
                success: 'Data deleted successfully!',
                error: 'Could not delete.',
            }
        )

        if (res && res.status === 200) {
            let newData = [...units];
            newData = newData.filter((item) => item._id !== id);
            setUnits(newData);
        }

    }

    const nameInputChangeHandler = (event) => {
        setCurrItem((prevState) => {
            return {
                ...prevState,
                name: event.target.value
            }
        })
    }

    const propertyInputChangeHandler = (event) => {
        setCurrItem((prevState) => {
            return {
                ...prevState,
                property: event.target.value
            }
        })
    }

    useEffect(() => {
        getSites();
        getUnits();
    }, [])

    return (
        <Fragment>
            <Header />
            <Navbar />
            <div className='container' >
                <div className='row'>
                    <div className="col-lg-12 mt-20">
                        <h3>Property Units</h3>
                        <hr />
                    </div>
                    <div className='col-lg-8'>
                        <table>
                            <thead>
                                <tr>
                                    <th>S.No</th>
                                    <th>Property</th>
                                    <th>Units</th>
                                    <th className="text-center">Action</th>
                                </tr>
                            </thead>
                            <tbody>
                                {
                                    units.map((unit, idx) => {
                                        return (
                                            <tr key={unit._id} >
                                                <td>{idx + 1}</td>
                                                <td>{unit.property.name}</td>
                                                <td>{unit.name}</td>
                                                <td>
                                                    <div className='flex p-relative' >
                                                        <button className="delete-btn" onClick={() => {
                                                            deleteData(unit._id)
                                                        }} ><i className='fa fa-times'></i></button>
                                                    </div>
                                                </td>
                                            </tr>
                                        )
                                    })
                                }
                            </tbody>
                        </table>
                    </div>
                    <div className='col-lg-4'>
                        <h5>Add Property Units</h5>
                        <hr />
                        <form className='user-form side-form' onSubmit={postData} >
                            <div className='form-group'>
                                <label>Select Property</label>
                                <select className='form-control shadow-none' name='adminType' onChange={propertyInputChangeHandler} value={currItem.property} >
                                    <option value="">Property ?</option>
                                    {
                                        properties.map((property) => {
                                            return (
                                                <option key={property._id} value={`${property._id}-${property.name}`}>{property.name}</option>
                                            )
                                        })
                                    }
                                </select>
                            </div>
                            <FormInput onChange={nameInputChangeHandler} value={currItem.name} autoComplete='off' id='name' type='text' label='Property Unit (For e.g. 1 BHK)' />
                            <PrimaryButton type='submit'>
                                Add
                            </PrimaryButton>
                        </form>
                    </div>
                </div>
            </div>
        </Fragment>
    )
}

export default Units;